import React from 'react';
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {formatNumber} from "../../../../common/utils/utils";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
let _ = require('lodash');

export const exportPDF = (name, order, orderId, orgImgCode) => {
    let infectious_protocol = [];

    let notes = [
        [
            {
                text: 'Created Date',
                fillColor: '#F2F2F2',
                alignment: 'center',
                border: [false, true, false, true],
                fontSize: 9,
                margin: [0, 0, 0, 0],
                textTransform: 'uppercase',
            },
            {
                text: 'Entered By',
                border: [true, true, false, true],
                alignment: 'center',
                fillColor: '#F2F2F2',
                fontSize: 9,
                margin: [0, 0, 0, 0],
                textTransform: 'uppercase',
            },
            {
                text: 'Comments',
                border: [true, true, false, true],
                alignment: 'center',
                fillColor: '#F2F2F2',
                fontSize: 9,
                margin: [0, 0, 0, 0],
                textTransform: 'uppercase',
            },
        ]
    ];
    let items = [[
        {
            text: 'Done',
            fillColor: '#F2F2F2',
            border: [true, true, false, true],
            fontSize: 9,
            margin: [0, 2, 0, 2],
            textTransform: 'uppercase',
        },
        {
            text: 'Qty',
            border: [true, true, false, true],
            alignment: 'center',
            fillColor: '#F2F2F2',
            fontSize: 9,
            margin: [0, 2, 0, 2],
            textTransform: 'uppercase',
        },
        {
            text: 'Item Name',
            border: [true, true, false, true],
            alignment: 'center',
            fillColor: '#F2F2F2',
            fontSize: 9,
            margin: [0, 2, 0, 2],
            textTransform: 'uppercase',
        },
        {
            text: 'Clinical settings',
            border: [true, true, false, true],
            alignment: 'center',
            fillColor: '#F2F2F2',
            fontSize: 9,
            margin: [0, 2, 0, 2],
            textTransform: 'uppercase',
        },
        {
            text: 'Inventory Info',
            border: [true, true, true, true],
            alignment: 'center',
            fillColor: '#F2F2F2',
            fontSize: 9,
            margin: [0, 2, 0, 2],
            textTransform: 'uppercase',
        }
    ],
    ];

    order.items.map(item => {
        items.push([
            {
                border: [true, false, true, true],
                image: 'data:image/png;base64,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',
                width: 14,
                margin: [0, 1, 100, 0],
            },
            {
                border: [true, false, false, true],
                text: item.quantity ? item.quantity : 1,
                fontSize: 9,
                alignment: 'center',
                margin: [0, 1, 0, 1],
            },
            {
                text: item.name,
                border: [true, false, false, true],
                fontSize: 9,
                margin: [0, 1, 0, 1],
                alignment: 'left',
            },
            {
                text: `${item.liters_per_minute === true && item.min_range ? 'Liters Per Minute -' : (item.min_range ? 'Air PSI -' : '')} ${item.min_range ? 'Min ' + item.min_range + ";" : ""} ${item.max_range ? 'Max ' + item.max_range + ";" : ""} ${item.humidifier_for_compressor ? 'Humidifier bottle:' + item.humidifier_for_compressor + " %" : ""} ${item.service_note ? 'Service Note: ' + item.service_note_text : ""} `,
                border: [true, false, false, true],
                fontSize: 9,
                margin: [0, 1, 0, 1],
                alignment: 'left',
            },
            {
                border: [true, false, true, true],
                text: '',
                fontSize: 9,
                alignment: 'right',
                margin: [0, 1, 0, 1],
            }
        ])
    });

    order.notes.map(note => {
        notes.push([
            {
                border: [true, false, false, true],
                text: `${moment(note.created_date).format("L")}`,
                fontSize: 9,
                alignment: 'center',
                margin: [0, 1, 0, 1],
            },
            {
                border: [true, false, false, true],
                text: `${note.first_name} ${note.last_name}`,
                fontSize: 9,
                alignment: 'center',
                margin: [0, 1, 0, 1],
            },
            {
                text: note.description,
                border: [true, false, false, true],
                fontSize: 9,
                margin: [0, 1, 0, 1],
                alignment: 'left',
            },

        ])
    });
    order.infectious_protocol.map(item => {
        const capitalize = (s) => {
            if (typeof s !== 'string') return '';
            return s.charAt(0).toUpperCase() + s.slice(1)
        };
        infectious_protocol.push({
                image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAMZWlDQ1BJQ0MgUHJvZmlsZQAASImVlwdYU8kWgOeWVBJaIAJSQm+iSA0gJYQWQUCqICohCSSUGBOCih1ZVsG1iyhWrIiLrq6ArAUR17oodteyWFBZWRdXsaHyJgV03Ve+N983d/6cOXPmnJOZe2cA0Ovky2T5qD4ABdJCeUJkKGtCWjqL9AiQgDEgA0PgxhcoZJz4+BgAy2D79/L6OkBU7RU3la1/9v/XYigUKQQAIBmQs4QKQQHkFgDwEoFMXggAMQzKbacXylQshmwkhw5Cnq3iHA0vV3GWhrerdZISuJCbACDT+Hx5DgC6bVDOKhLkQDu6jyC7S4USKQB6RpCDBGK+EHIS5BEFBVNVPB+yE9SXQd4NmZ31hc2cv9nPGrLP5+cMsSYudSGHSRSyfP7M/zM1/7sU5CsH53CAlSaWRyWo4oc5vJk3NVrFNMg90qzYOFWuIb+VCDV5BwClipVRyRp91Fyg4ML8ASZkdyE/LBqyOeQIaX5sjFaelS2J4EGGqwWdISnkJWnHLhIpwhO1NjfIpybEDXK2nMvRjq3ny9XzqvTblHnJHK39m2IRb9D+q2JxUipkKgAYtUiSEgtZF7KRIi8xWqOD2RSLubGDOnJlgsp/O8hskTQyVGMfy8iWRyRo9WUFisF4sTKxhBer5apCcVKUJj/YHgFf7b8J5AaRlJM8aEekmBAzGItQFBauiR1rF0mTtfFi92SFoQnasb2y/HitPk4W5Ueq5DaQzRRFidqx+JhCuDg19vEYWWF8ksZPPDOXPzZe4w9eBGIAF4QBFlDCmgWmglwgae9p7IG/ND0RgA/kIAeIgJtWMjgiVd0jhc9EUAz+gCQCiqFxoepeESiC8o9DUs3TDWSre4vUI/LAY8gFIBrkw99K9Sjp0Gwp4BGUSP4xuwD6mg+rqu+fMg6UxGglykG7LL1BTWI4MYwYRYwgOuNmeBAegMfAZwisHjgb9xv09rM+4TGhg/CAcI3QSbg1RVIi/8qXcaAT2o/QRpz1ZcS4A7TpjYfigdA6tIwzcTPghnvBeTh4MJzZG0q5Wr9VsbP+TZxDEXyRc60exZ2CUoZRQihOX4/UddH1HrKiyuiX+dH4mjWUVe5Qz9fzc7/IsxC20V9rYouwg9hp7AR2FjuCNQIWdhxrwi5gR1U8tIYeqdfQ4GwJan/yoB3JP+bja+dUZVLhXufe7f5B2wcKRTMKVRuMO1U2Uy7JEReyOPArIGLxpIKRI1ge7h7uAKi+KZrX1Eum+luBMM99li30BSCwdGBg4MhnWfQOAA6mwW1+9bPM8R18F9sCcGaTQCkv0shw1YMA3wZ6cEeZAktgC5xgRB7ABwSAEBAOxoI4kATSwGSYZzFcz3IwHcwGC0AZqADLwRqwHmwG28Bu8D04ABrBEXAC/AzOg0vgGrgN108XeAZ6wWvQjyAICaEjDMQUsULsEVfEA2EjQUg4EoMkIGlIJpKDSBElMhtZiFQgK5H1yFakFvkBOYycQM4iHcgt5D7SjfyFvEcxlIYaoRaoAzoKZaMcNBpNQiehOeg0tBgtRZeiVWgNuhdtQE+g59FraCf6DO3DAKaDMTFrzA1jY1wsDkvHsjE5NhcrxyqxGqwea4b/9BWsE+vB3uFEnIGzcDe4hqPwZFyAT8Pn4kvw9fhuvAFvw6/g9/Fe/BOBTjAnuBL8CTzCBEIOYTqhjFBJ2Ek4RDgFd1MX4TWRSGQSHYm+cDemEXOJs4hLiBuJ+4gtxA7iQ2IfiUQyJbmSAklxJD6pkFRGWkfaSzpOukzqIr0l65CtyB7kCHI6WUouIVeS95CPkS+Tn5D7KfoUe4o/JY4ipMykLKNspzRTLlK6KP1UA6ojNZCaRM2lLqBWUeupp6h3qC91dHRsdPx0xutIdObrVOns1zmjc1/nHc2Q5kLj0jJoStpS2i5aC+0W7SWdTnegh9DT6YX0pfRa+kn6PfpbXYbuSF2erlB3nm61boPuZd3nehQ9ez2O3mS9Yr1KvYN6F/V69Cn6Dvpcfb7+XP1q/cP6N/T7DBgGow3iDAoMlhjsMThr8NSQZOhgGG4oNCw13GZ40vAhA2PYMrgMAWMhYzvjFKPLiGjkaMQzyjWqMPreqN2o19jQ2Ms4xXiGcbXxUeNOJsZ0YPKY+cxlzAPM68z3wyyGcYaJhi0eVj/s8rA3JsNNQkxEJuUm+0yumbw3ZZmGm+aZrjBtNL1rhpu5mI03m262yeyUWc9wo+EBwwXDy4cfGP6rOWruYp5gPst8m/kF8z4LS4tIC5nFOouTFj2WTMsQy1zL1ZbHLLutGFZBVhKr1VbHrX5nGbM4rHxWFauN1Wttbh1lrbTeat1u3W/jaJNsU2Kzz+auLdWWbZttu9q21bbXzspunN1suzq7X+0p9mx7sf1a+9P2bxwcHVIdvnVodHjqaOLIcyx2rHO840R3Cnaa5lTjdNWZ6Mx2znPe6HzJBXXxdhG7VLtcdEVdfVwlrhtdO0YQRviNkI6oGXHDjebGcStyq3O7P5I5MmZkycjGkc9H2Y1KH7Vi1OlRn9y93fPdt7vfHm04euzoktHNo//ycPEQeFR7XPWke0Z4zvNs8nzh5eol8trkddOb4T3O+1vvVu+PPr4+cp96n25fO99M3w2+N9hG7Hj2EvYZP4JfqN88vyN+7/x9/Av9D/j/GeAWkBewJ+DpGMcxojHbxzwMtAnkB24N7AxiBWUGbQnqDLYO5gfXBD8IsQ0RhuwMecJx5uRy9nKeh7qHykMPhb7h+nPncFvCsLDIsPKw9nDD8OTw9eH3ImwiciLqInojvSNnRbZEEaKio1ZE3eBZ8AS8Wl7vWN+xc8a2RdOiE6PXRz+IcYmRxzSPQ8eNHbdq3J1Y+1hpbGMciOPFrYq7G+8YPy3+p/HE8fHjq8c/ThidMDvhdCIjcUrinsTXSaFJy5JuJzslK5NbU/RSMlJqU96khqWuTO2cMGrCnAnn08zSJGlN6aT0lPSd6X0TwyeumdiV4Z1RlnF9kuOkGZPOTjabnD/56BS9KfwpBzMJmamZezI/8OP4Nfy+LF7WhqxeAVewVvBMGCJcLewWBYpWip5kB2avzH6aE5izKqdbHCyuFPdIuJL1khe5Ubmbc9/kxeXtyhvIT83fV0AuyCw4LDWU5knbplpOnTG1Q+YqK5N1TvOftmZarzxavlOBKCYpmgqN4OH9gtJJ+Y3yflFQUXXR2+kp0w/OMJghnXFhpsvMxTOfFEcU75iFzxLMap1tPXvB7PtzOHO2zkXmZs1tnWc7r3Re1/zI+bsXUBfkLfilxL1kZcmrhakLm0stSueXPvwm8pu6Mt0yedmNbwO+3bwIXyRZ1L7Yc/G6xZ/KheXnKtwrKis+LBEsOffd6O+qvhtYmr20fZnPsk3Liculy6+vCF6xe6XByuKVD1eNW9WwmrW6fPWrNVPWnK30qty8lrpWubazKqaqaZ3duuXrPqwXr79WHVq9b4P5hsUb3mwUbry8KWRT/WaLzRWb32+RbLm5NXJrQ41DTeU24raibY+3p2w/vYO9o3an2c6KnR93SXd17k7Y3VbrW1u7x3zPsjq0TlnXvTdj76Xvw75vqner37qPua9iP9iv3P/7D5k/XD8QfaD1IPtg/Y/2P244xDhU3oA0zGzobRQ3djalNXUcHnu4tTmg+dBPI3/adcT6SPVR46PLjlGPlR4bOF58vK9F1tJzIufEw9YprbdPTjh5tW18W/up6FNnfo74+eRpzunjZwLPHDnrf/bwOfa5xvM+5xsueF849Iv3L4fafdobLvpebLrkd6m5Y0zHscvBl09cCbvy81Xe1fPXYq91XE++fvNGxo3Om8KbT2/l33rxa9Gv/bfn3yHcKb+rf7fynvm9mt+cf9vX6dN59H7Y/QsPEh/cfih4+OyR4tGHrtLH9MeVT6ye1D71eHqkO6L70u8Tf+96JnvW31P2h8EfG547Pf/xz5A/L/RO6O16IX8x8NeSl6Yvd73yetXaF99373XB6/435W9N3+5+x353+n3q+yf90z+QPlR9dP7Y/Cn6052BgoEBGV/OVx8FMFjR7GwA/toFAB2eHRiX4PlhoubOpy6I5p6qJvCfWHMvVBcfAOphozquc1sA2A+rw3z1lQSojupJIQD19Byq2qLI9vTQ2KLBGw/h7cDASwsASM0AfJQPDPRvHBj4CO+o2C0AWqZp7pqqQoR3gy0hKrpmknkTfFU099AvYvy6BSoPvMDX7b8ArQKI6enuVJQAAACKZVhJZk1NACoAAAAIAAQBGgAFAAAAAQAAAD4BGwAFAAAAAQAAAEYBKAADAAAAAQACAACHaQAEAAAAAQAAAE4AAAAAAAAAkAAAAAEAAACQAAAAAQADkoYABwAAABIAAAB4oAIABAAAAAEAAACAoAMABAAAAAEAAACAAAAAAEFTQ0lJAAAAU2NyZWVuc2hvdMS7wkkAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAHWaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA1LjQuMCI+CiAgIDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICAgICAgICAgIHhtbG5zOmV4aWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vZXhpZi8xLjAvIj4KICAgICAgICAgPGV4aWY6UGl4ZWxYRGltZW5zaW9uPjEyODwvZXhpZjpQaXhlbFhEaW1lbnNpb24+CiAgICAgICAgIDxleGlmOlVzZXJDb21tZW50PlNjcmVlbnNob3Q8L2V4aWY6VXNlckNvbW1lbnQ+CiAgICAgICAgIDxleGlmOlBpeGVsWURpbWVuc2lvbj4xMjg8L2V4aWY6UGl4ZWxZRGltZW5zaW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KF4beEAAAABxpRE9UAAAAAgAAAAAAAABAAAAAKAAAAEAAAABAAAAG9uKueQAAAAbCSURBVHgB7FzNTxRJFH+AoCgY4wJBljCL8inRg5hlcRNZgbiJsAdj/EANZz3pkYSD/gdcCPHmnWCIWQ9mTdDl+8uFdRUPLmBcEU1w+Q6fulu/ztZGZ3p66OrqcXrmvaTTTDVdU+/9flX13quqiftHCLHErAXimAAxi72hOBMgtvEnJgATgH2AWOYAjwCxjL7QnQnABOApIJY5wCNALKPPU0CMo88EYALwFBDjHGACMAHcjwKw3vTx40fCXV4xbndT9ePi4ghXfHy8cZn+k+ZCV0eADx8+GMAvLi7SzPv3ND83R0vLy7S2ukobm5uaVfFudQA9KSmJknfupNRdu2jv3r2Unp5OiYmJlJCQYJDCLe1cIQB6O8B/9eoVTb15Q/Pz8261P6rrzcrKouzsbPpKEMItImgnwKbo2VNTUzQ+MUHLorezOLfAvn37KC8vj1JTUylBTA86RRsBMLevr6/T02fP6I3o9Sx6LYARoKioiHw5OcZooKt2LQQA+ItLSzQyMkILCwu62sb1mFggNzeXigoLadu2bSZP7RdpIcCCcPKGh4dDDvnSu5Xerv3mRu8bMjqC/4TLSnw+H5UcPKhlJHBMAAz7ff39QXs+wMbwtX37dsrMzKQM4d0mJyfTjh07tChgZSivPIMNV0VkBGf57bt39LeImDb/i6CC6ZAvfIKCggLH4aIjAoCpI6OjQed89PiUlBTCsAVvNl6QgSW0BVZWVgwnGs70xsaGkTsxe+vIkSP0tYgUnIgjAiDM+/3JE9PvR6/PEt7roUOHuKebWih0IUaE34RfhWgKU4S/7BR5gx8qKhzZV5kAiPN/7ew0nffR8/Pz86lAXCzOLLC2tkbDjx/T7OysKQkQHhaL6EBVlAkwOTlphHz+X4w5H0M+nBQWPRYACXp6e007G7KFVZWVRtZQ5duUCIDhqKu72zTDhzTm98eOqbSF37GwwKxIo/cKEphFCCUlJbRfdDoVUSIA5qbOrq6A70Pv/66sjNLS0gKecYFzC2AqmJ6eDqgIne5YebnSmoESAf4cH6fnz58HNGSXWMioPHEioJwL9FhgZmbGCLnNavvx5EljQcnsmVWZEgGQ9Jl++zagXsSlheJicccCmHp/efDASLn7f0PZt2WUkZHuXxzysxIBHj16ZKR+/WuvOH6cdu/e7V/MnzVaYFTkXf56/TqgxpKDwg/Yb98PUCLA/fv3Tdfza2tqlOahAG24IKgFxsX0O2Yy/eYdOEDFxcVB3wv2QIkAP9+7Z1rfT7W1puVcqM8CL1++pD+ePg2o8BuxPoCkm13RRgAkf2pOnbL7/fz/Ni0QLPvqy/HR4cNMAJvm9N6/MwE8ghk8dmTwsEMKf2P9Hvv+sEbiRJgATqwXpncBOhI2d+/epbGxMcLqHtZGqqurjXkay+GqwgRQtVyY3sPybZfIkl69etU0a3fz5k26cuUKYSVPRZgAKlYL0zsA/+HDh3T27FnTlTvZjOvXr1NDQ4MSCZgA0ooRdsew39HRERJ82WxVEjABpAUj6A7wkR09c+aMZc/3b7IKCZgA/lb8wp9VwZfNtksCJoC0XATcnYIvVbBDAiaAtNoXvusCX6oBEjQ2Nhq7p2WZ2Z0JYGaVMJcB/E6xH/L06dO25vxQzWxpaaFLly5ZLqgxAUJZ0eXnEvzLly/TkjgNpVOwoWZCnKm0ShQxAXRa3GZdboIvm9LT02O5qscEkJYK8x3gI8OHIVp3z/9Ulfb2dqqqqvq06LO/mQCfmSM8H8IFPpbUh4aGjHWDYJoxAYJZxqXycIGP5heKU799fX2WJ3+ZAC4BbVZtOMHHjz+0tbVRudjebSVMACvraHwG8LvF4ZeLFy+6OuejyQC/ubnZCCtDqRD1BMAmCqyq4ewhNk9gIwWOkodTIhV82CBqCYAjT3Pi+NOdO3doYGDAUDRH/BzK0aNH6dy5c7Rnzx7HZ+G3QiKAj1Csrq4uonq+bHtUEgDgY7szNlEMDg5KXf+/l5aW0q1btwzvGJ6yWxLp4EPvqCOABP/ChQv04sWLoNjixHFra6trJAD4OHyJdrgZ50NBO3O+v0GiigBbBV8awS0SeAV82CFqCGAXfLdIAPARe58/fz6ie77UPyoIoAq+NIKukcBr4EN/zxPAKfi6SOBF8KOCAPD2EdZZOXwS5FB31ZHAq+B7ngD4LTxsnMSqmi6xSwIvg+95AuCkTH19vdZdNDDKVkkA8PvFj1piBIrkUM+qc3jaB7hx4wY1NTVZ6af8LBQJogF8GMfTBLh27Rrdvn1bGeRQLwYjAcBHehkndrza86XuugnwLwAAAP//3bX1kwAABflJREFU7ZzJT91GHMd/7CD2VSIEXhCi0CQEhUpAhZoU0ktoegCJv4J/gAMgTpxBAnGAAxcuXJtGatRIjUSJELkAoYQ1gogIRJAoYV/SztfqKI794D3bz372eEaybI/Hs/y+nzer38T8yxwZdL8+fap7IzY2ln5ubtb5qz2Ghoaoo6ODTCSpjuba69LSUhofH6fy8nJCni4uLmhqaora2tro4ODg2netPkxPT6eBgQFqaWmxGtWV729sbNDM7KzueaAkQPfuVen8Q3nEOAnAwsICNTU10eHhYah8WXrOIcB5enpaGPFhFE8DgAL09fVRb28vnZyc4NY2B/F7enqovb1diF8+N5TnAfj8+TN1dXXR8PCw7RBwo9l5dqLaV+ff8wCgMKJA4LT4sJ0QAIgAQTTEFwoAL0MQLfGFA8CLEERTfCEB8BIE0RZfWAC8AIEbxBcaADdD4BbxhQfAjRC4SXxfAOAmCNwmvm8AcAMEbhTfVwBEEwK3iu87ADgEnZ2dNDIy4sjagZvF9yUATkLgdvF9C4ATEKSlpdHg4KCtH3OgHFadMItBZgyBVUQ7mgOIjy95WltbzWTL0Xd8DQAsHWkIvCQ+yu97AGCEy8tL5aMSqx1Dr4kvAYAF/ndWIfCi+Ci6rAE4AexsFgKvii8BUInPL41C4GXxJQBcdc05XAi8Lr4EQCO8+pZDMDo6qvsMHH8QwSRPf3+/J4Z66nJpr2UfQGsR1T2GiGNjY9Td3a38Iwj3cXFxVFBQoIjf0NCgCu3NSwlAGLrt7+/T4uIibW9vUyAQUP4mlpycHMab7g8iAXC/RrbmUAJgq3ndH7kEwP0a2ZpDCYCt5nV/5BIA92tkaw5dCwBK/cuTJ7YWXkbO1gLev6eZmRmdKRzdIOK3Z8+UZVltLpofP1bG3Vp/eR85C6yurtLfbKMNrSu9VUp3797Reoe8N7VDyB8vXtDx8bEu8sbGRkpLTdX5S4/IWWB+fp7W3r3TRVhZUaHMd+gehPAwBcDkq1e0u7uri7qmpoaKbtzQ+UuPyFngStvfv09FRUWGEzIFwFUUFt+8SdXV1RQTE2M4I/KF0BY4Pz+n358/122yBXs/+OEBZWSkh45EE8IUAFtbWzT9+rUmKqKEhAT68eFDEmXaVVfAKHussPYfG21pXUpKCv306JHWO6x7UwBg5Q0k4qx1ZWVl9G1lpawFtIaxeH92dkZ/vnxJp6enuphusfWOqirjW8QhIlMA4MXZuTlaX1/H5VcOS6+1tbWUl5srIfjKMuZv8EPD3oCbm5u6SGDv+ro6ymX2NuNMA7C3t0d/TU4GHQ6iKfi+vp61SRkSAjOqqN6B+Kj6l5aWVL5fLvPz8xUAvvgYuzINAJIBlZiZCuaSkpKohvVMs7Oz5dxAMAOF4YddTpeWlwlj/2CO17b5eXnBHoflZwmAIzYXMDExEbRd4qnfuX2biouLKT4+XtYG3CghzvjVYyPNuTdvaGdnJ2ho9PwDJSWm234eqSUAEAnaJdQEwTqEPJGsrCz6hu3di9oAGecHf+73M987GWd08rbYhywrKyuEYd9VLjMzU2lm0dxacZYBQOLLrJpaZhm+DgKeySyWcQxbMFSMZZ9rSUeK6BD+6OgorH2UExMTqY51/GBLqy4iACATi6yTgrYqHAisZtqv76PmhPjfsRlXs71+re0iBgAiXltbUzot6Lzwak2boLw3ZwF0+DCqwng/Er98nouIAoBIdz5+pMW3b2n/0ydZG3ArWzhDeByYZq9gCz5W23xtViIOAE9gldUGmChC24bPs3FIF54FUNXH4mB9pJycHMLW91aGetelahsASBSib374oHyejdVDNAv8uC5Tfn3GR0foIEPwwsJCBQA77WErAOqMo3P4D/teHz3dM1YrKP0EdQAfX6OKT2DzJBA+lW1Wkc4Op5xjADhVIJmOMQtIAIzZS7jQEgDhJDVWIAmAMXsJF1oCIJykxgokATBmL+FCSwCEk9RYgSQAxuwlXGgJgHCSGiuQBMCYvYQLLQEQTlJjBZIAGLOXcKH/A2gA9Qgnxl3lAAAAAElFTkSuQmCC',
                width: 14,
                margin: [0, 4, 100, 0],
            },
            {
                text: `${capitalize(item.name)} Infectious`,
                bold: false,
                fontSize: 10,
                color: '#333333',
                margin: [-18, 6, 0, 3],
            })
    });


    let template = {
        content: [
            {
                image: orgImgCode,
                width: 50
            },
            {
                layout: {
                    defaultBorder: false,
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        if (i === 1 || i === 0) {
                            return '#bfdde8';
                        }
                        return '#eaeaea';
                    },
                    vLineColor: function (i, node) {
                        return '#eaeaea';
                    },
                    hLineStyle: function (i, node) {
                        return null;
                    },
                    paddingLeft: function (i, node) {
                        return 10;
                    },
                    paddingRight: function (i, node) {
                        return 10;
                    },
                    paddingTop: function (i, node) {
                        return 2;
                    },
                    paddingBottom: function (i, node) {
                        return 2;
                    },
                    fillColor: function (rowIndex, node, columnIndex) {
                        return '#333';
                    },
                },

                table: {
                    headerRows: 1,
                    widths: [240, 230],
                    heights: ['*', 100],
                    alignment: 'justified',
                    body: [
                        [
                            {
                                text: `Delivery Order #${"D100" + orderId}`,
                                fillColor: '#eeeeee',
                                fontSize: 10,
                                alignment: 'left',
                                bold: true,
                                border: [false, false, false, false],
                                margin: [0, 2, 0, 2],
                                textTransform: 'uppercase',
                            },

                            {
                                text: `Order Priority: ${order.priority_code ? order.priority_code : ""}`,
                                border: [false, false, false, false],
                                alignment: 'right',
                                fontSize: 10,
                                bold: true,
                                fillColor: '#eeeeee',
                                margin: [0, 2, 0, 2],
                                textTransform: 'uppercase',
                            },
                        ]
                    ]
                },
            },
            {
                columns: [
                    [
                        {
                            text: `${order.hospice_name ? order.hospice_name : ""}`,
                            color: '#333333',
                            width: '*',
                            fontSize: 12,
                            bold: true,
                            alignment: 'left',
                            margin: [10, 2, 0, 2],
                        },
                        {
                            text: `${order.hospice_organization_address1 ? order.hospice_organization_address1 : ""} ${order.hospice_organization_address2 ? order.hospice_organization_address2 : ""}`,
                            color: '#333333',
                            width: '*',
                            fontSize: 10,
                            bold: false,
                            alignment: 'left',
                            margin: [10, 0, 0, 2],
                        },
                        {
                            text: `${order.hospice_organization_city ? order.hospice_organization_city : ""}, ${order.hospice_organization_state ? order.hospice_organization_state : ""} ${order.hospice_organization_zip ? order.hospice_organization_zip : ""}`,
                            color: '#333333',
                            width: '*',
                            fontSize: 10,
                            bold: false,
                            alignment: 'left',
                            margin: [10, 0, 0, 2],
                        },
                        {
                            text: `${order.hospice_organization_phone ? 'Phone:' + formatNumber(order.hospice_organization_phone) : ""}`,
                            color: '#333333',
                            width: '*',
                            fontSize: 10,
                            bold: false,
                            alignment: 'left',
                            margin: [10, 0, 0, 2],
                        },
                    ],
                    [
                        {
                            text: `Medical Director#:${order.hospice_medical_director ? order.hospice_medical_director : ""}`,
                            color: '#333333',
                            width: '*',
                            fontSize: 9,
                            bold: false,
                            alignment: 'left',
                            margin: [0, 0, 0, 2],
                        },
                        {
                            text: `Pharmacy#:${order.hospice_pharmacy ? order.hospice_pharmacy : ""}`,
                            color: '#333333',
                            width: '*',
                            fontSize: 9,
                            bold: false,
                            alignment: 'left',
                            margin: [0, 0, 0, 2],
                        },
                    ],
                    [
                        {
                            text: `Requested Delivery Date: ${order.preferred_date ? moment(order.preferred_date).format("L") : ""}`,
                            color: '#333333',
                            width: '*',
                            fontSize: 10,
                            bold: false,
                            alignment: 'right',
                            margin: [0, 6, 0, 2],
                        },
                        {
                            text: `Delivery created by: ${order.user_first_name} ${order.user_last_name}`,
                            color: '#333333',
                            width: '*',
                            fontSize: 10,
                            bold: false,
                            alignment: 'right',
                            margin: [0, 6, 0, 2],
                        },
                    ],
                ],
            },
            {
                table: {
                    widths: [240, 255],
                    heights: ['*', 1],
                    alignment: 'center',
                    body: [
                        [
                            {
                                text: '',
                                fontSize: 1,
                                alignment: 'left',
                                bold: true,
                                border: [false, true, false, false],
                                margin: [100, 1, 0, 1],
                                textTransform: 'uppercase',
                            },
                            {
                                text: '',
                                border: [false, true, false, false],
                                alignment: 'right',
                                fontSize: 1,
                                bold: true,
                                margin: [0, 1, 100, 1],
                                textTransform: 'uppercase',
                            },
                        ]
                    ]
                },
            },
            {
                columns: [

                    {
                        text: `Patient: ${order.first_name} ${order.last_name} (ID:${order.patient_id})`,
                        bold: true,
                        fontSize: 10,
                        alignment: 'left',
                        margin: [10, 0, 0, 0],
                    },
                    {
                        text: `Primary Contact: ${order.caregivers[0].caregiver_first_name}`,
                        bold: true,
                        fontSize: 10,
                        alignment: 'left',
                        margin: [0, 0, 0, 0],
                    },
                    {
                        text: ` ${order.caregivers[1] ? 'Secondary Contact:' + order.caregivers[1].caregiver_first_name : ""}`,
                        bold: true,
                        fontSize: 10,
                        alignment: 'left',
                        color: '#333333',
                        margin: [0, 0, 0, 0],
                    },
                ],
            },
            {
                columns: [
                    {
                        text: `MRN: ${order.medical_record ? order.medical_record : ""}`,
                        fontSize: 10,
                        color: '#333333',
                        alignment: 'left',
                        margin: [10, 0, 0, 0],
                    },
                    {
                        text: `Phone:  ${formatNumber(order.caregivers[0].caregiver_phone_number)}`,
                        fontSize: 10,
                        color: '#333333',
                        alignment: 'left',
                    },
                    {
                        text: `${order.caregivers[1] ? 'Phone:' + formatNumber(order.caregivers[1].caregiver_phone_number) : ""}`,
                        bold: false,
                        fontSize: 10,
                        color: '#333333',
                        margin: [0, 0, 0, 0],
                    },
                ],
            },
            {
                columns: [
                    {
                        text: `Location: ${order.care_setting ? order.care_setting : ""}`,
                        fontSize: 10,
                        color: '#333333',
                        alignment: 'left',
                        margin: [10, 0, 0, 0],
                    },
                    {
                        text: `Relationship: ${order.caregivers[0].caregiver_relation}`,
                        fontSize: 10,
                        color: '#333333',
                        alignment: 'left',
                    },
                    {
                        text: `${order.caregivers[1] ? 'Relationship:' + order.caregivers[1].caregiver_relation : ""}`,
                        bold: false,
                        fontSize: 10,
                        color: '#333333',
                        margin: [0, 0, 0, 5],
                    },

                ],
            },
            {
                columns: [
                    {
                        text: `Address: ${order.address1 ? order.address1 : ""} ${order.address2 ? order.address2 : ""}\n ${order.city ? order.city : ""} ${order.state ? order.state : ""}, ${order.zip ? order.zip : ""}`,
                        fontSize: 10,
                        color: '#333333',
                        alignment: 'left',
                        margin: [10, 0, 0, 0],
                    },
                    {
                        text: ` ${order.caregivers[2] ? 'Third Contact:' + order.caregivers[2].caregiver_first_name : ""}`,
                        bold: true,
                        fontSize: 10,
                        color: '#333333',
                        margin: [0, 0, 0, 0],
                    },
                    {}
                ],
            },
            {
                columns: [
                    {
                        text: `Phone: ${order.phone_number !== null ? formatNumber(order.phone_number) : ""}`,
                        fontSize: 10,
                        color: '#333333',
                        margin: [10, 0, 0, 0],
                    },
                    {
                        text: `${order.caregivers[2] ? 'Phone:' + formatNumber(order.caregivers[2].caregiver_phone_number) : ""}`,
                        bold: false,
                        fontSize: 10,
                        color: '#333333',
                        margin: [0, 0, 0, 0],
                    },
                    {}
                ],
            },
            {
                columns: [
                    {
                        text: `Nurse: ${order.nurse_name ? order.nurse_name : ""}`,
                        fontSize: 10,
                        color: '#333333',
                        margin: [10, 0, 0, 0],
                    },
                    {
                        text: `${order.caregivers[2] ? 'Relationship:' + order.caregivers[2].caregiver_relation : ""}`,
                        bold: false,
                        fontSize: 10,
                        color: '#333333',
                        margin: [0, 0, 0, 5],
                    },
                    {}
                ]

            },
            {
                columns: [
                    {
                        text: `${order.patient_weight ? 'Weight: ' + order.patient_weight.toString() + ' lb' : ''}; ${order.patient_height_in_feet ? 'Height: ' + order.patient_height_in_feet.toString() + ' feet' : ''}  ${order.patient_height_in_inches ? order.patient_height_in_inches.toString() + ' inches' : ''}`,
                        bold: false,
                        fontSize: 10,
                        color: '#333333',
                        margin: [10, 0, 0, 0],
                    }
                ]
            },
            {
                columns: [
                    {
                        text: `Facility: ${order.facility_name ? order.facility_name : ""}`,
                        bold: false,
                        fontSize: 10,
                        color: '#333333',
                        margin: [10, 0, 0, 0],
                    }
                ]
            },
            {
                table: {
                    widths: [240, 255],
                    heights: ['*', 1],
                    alignment: 'center',
                    body: [
                        [
                            {
                                text: '',

                                fontSize: 1,
                                alignment: 'left',
                                bold: true,
                                border: [false, true, false, false],
                                margin: [100, 1, 0, 1],
                                textTransform: 'uppercase',
                            },

                            {
                                text: '',
                                border: [false, true, false, false],
                                alignment: 'right',
                                fontSize: 1,
                                bold: true,
                                margin: [0, 1, 100, 1],
                                textTransform: 'uppercase',
                            },
                        ]
                    ]
                },

            },
            {
                columns: infectious_protocol
            },
            {
                layout: {
                    defaultBorder: false,
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#000000';
                    },
                    vLineColor: function (i, node) {
                        return '#000000';
                    },
                    paddingLeft: function (i, node) {
                        return 10;
                    },
                    paddingRight: function (i, node) {
                        return 10;
                    },
                    paddingTop: function (i, node) {
                        return 2;
                    },
                    paddingBottom: function (i, node) {
                        return 2;
                    },
                    fillColor: function (rowIndex, node, columnIndex) {
                        return '#fff';
                    },
                },
                table: {
                    headerRows: 1,
                    widths: [21, 15, 150, 130, 100],
                    margin: [0, 0, 0, 6],
                    body: items
                },
            },
            '\n',
            {
                layout: {
                    defaultBorder: false,
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        if (i === 1 || i === 0) {
                            return '#bfdde8';
                        }
                        return '#eaeaea';
                    },
                    vLineColor: function (i, node) {
                        return '#eaeaea';
                    },
                    hLineStyle: function (i, node) {
                        return null;
                    },
                    paddingLeft: function (i, node) {
                        return 10;
                    },
                    paddingRight: function (i, node) {
                        return 10;
                    },
                    paddingTop: function (i, node) {
                        return 2;
                    },
                    paddingBottom: function (i, node) {
                        return 0;
                    },
                    fillColor: function (rowIndex, node, columnIndex) {
                        return '#333';
                    },
                },
                table: {
                    headerRows: 1,
                    widths: [500],
                    heights: ['*', 100],
                    alignment: 'center',
                    body: [
                        [
                            {
                                text: 'Order Notes',
                                fillColor: '#eeeeee',
                                fontSize: 10,
                                alignment: 'left',
                                bold: true,
                                border: [false, false, false, false],
                                margin: [228, 0, 0, 0],
                                textTransform: 'uppercase',
                            },
                        ]
                    ]
                },

            },
            {
                layout: {
                    defaultBorder: false,
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        if (i === 1 || i === 0) {
                            return '#F2F2F2';
                        }
                        return '#eaeaea';
                    },
                    vLineColor: function (i, node) {
                        return '#eaeaea';
                    },
                    hLineStyle: function (i, node) {
                        return null;
                    },
                    paddingLeft: function (i, node) {
                        return 10;
                    },
                    paddingRight: function (i, node) {
                        return 10;
                    },
                    paddingTop: function (i, node) {
                        return 2;
                    },
                    paddingBottom: function (i, node) {
                        return 2;
                    },
                    fillColor: function (rowIndex, node, columnIndex) {
                        return '#fff';
                    },
                },
                table: {
                    headerRows: 1,
                    widths: [70, 90, 298,],
                    body: notes
                },
            },
            {
                columns: [
                    {
                        text: '',
                        fontSize: 10,
                        alignment: 'left',
                        margin: [0, 4, 0, 4],
                    },
                ]
            },
            {
                layout: {
                    defaultBorder: false,
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        if (i === 1 || i === 0) {
                            return '#bfdde8';
                        }
                        return '#eaeaea';
                    },
                    vLineColor: function (i, node) {
                        return '#eaeaea';
                    },
                    hLineStyle: function (i, node) {
                        return null;
                    },
                    paddingLeft: function (i, node) {
                        return 10;
                    },
                    paddingRight: function (i, node) {
                        return 10;
                    },
                    paddingTop: function (i, node) {
                        return 1;
                    },
                    paddingBottom: function (i, node) {
                        return 2;
                    },
                    fillColor: function (rowIndex, node, columnIndex) {
                        return '#333';
                    },
                },
                table: {
                    headerRows: 1,
                    widths: [500],
                    heights: ['*', 100],
                    alignment: 'center',
                    body: [
                        [
                            {
                                text: 'Driver Notes',
                                fillColor: '#eeeeee',
                                fontSize: 10,
                                alignment: 'left',
                                bold: true,
                                border: [false, false, false, false],
                                margin: [230, 0, 0, 0],
                                textTransform: 'uppercase',
                            },

                        ]
                    ]
                },

            },
            {
                columns: [
                    {
                        text: `Driver: ${order.technician_name !== null ? order.technician_name : ""}`,
                        bold: true,
                        fontSize: 10,
                        alignment: 'left',
                        margin: [0, 4, 0, 4],
                    },
                ]
            },
            {
                columns: [
                    {
                        text: 'Arrival:',
                        bold: false,
                        fontSize: 10,
                        color: '#333333',
                        margin: [0, 0, 0, 3],
                    },
                    {
                        canvas: [
                            {
                                type: 'polyline',
                                lineWidth: 1,
                                closePath: true,
                                points: [{x: -60, y: 14}, {x: 60, y: 14}]
                            }
                        ]
                    },
                    {
                        text: 'Departure:',
                        bold: false,
                        fontSize: 10,
                        color: '#333333',
                        margin: [-16, 0, 0, 3],
                    },
                    {
                        canvas: [
                            {
                                type: 'polyline',
                                lineWidth: 1,
                                closePath: true,
                                points: [{x: -60, y: 14}, {x: 60, y: 14}]
                            }
                        ]
                    },
                    {
                        canvas: [
                            // {
                            //     type: 'polyline',
                            //     lineWidth: 1,
                            //     closePath: true,
                            //     points: [{x: 60, y: -2}, {x: -60, y: -2}, {x: -60, y: 14}, {x: 60, y: 14}]
                            // }
                        ]
                    },

                ]
            },
            '\n',
            {
                columns: [

                    {
                        text: 'Contact:',
                        fontSize: 10,
                        bold: false,
                        color: '#333333',
                        margin: [0, 0, 0, 3],
                    },
                    {
                        canvas: [
                            {
                                type: 'polyline',
                                lineWidth: 1,
                                closePath: true,
                                points: [{x: -46, y: 0}, {x: -60, y: 0}, {x: -60, y: 14}, {x: -46, y: 14}]
                            }
                        ]
                    },
                    {
                        text: 'No contact:',
                        bold: false,
                        fontSize: 10,
                        color: '#333333',
                        margin: [-16, 0, 0, 3],
                    },
                    {
                        canvas: [
                            {
                                type: 'polyline',
                                lineWidth: 1,
                                closePath: true,
                                points: [{x: -46, y: 0}, {x: -60, y: 0}, {x: -60, y: 14}, {x: -46, y: 14}]
                            }
                        ]
                    },

                    {
                        canvas: [
                            // {
                            //     type: 'polyline',
                            //     lineWidth: 1,
                            //     closePath: true,
                            //     points: [{x: 60, y: -2}, {x: -60, y: -2}, {x: -60, y: 14}, {x: 60, y: 14}]
                            // }
                        ]
                    },

                ]
            },
            '\n',
            {
                columns: [
                    {
                        canvas: [
                            {
                                type: 'polyline',
                                lineWidth: 1,
                                closePath: true,
                                points: [{x: 14, y: 0}, {x: 0, y: 0}, {x: -0, y: 14}, {x: 14, y: 14}]
                            }
                        ]
                    },
                    {
                        text: 'Signs of Smoking',
                        fontSize: 10,
                        bold: false,
                        color: '#333333',
                        margin: [-112, 0, 0, 3],
                    },
                    {
                        canvas: [
                            {
                                type: 'polyline',
                                lineWidth: 1,
                                closePath: true,
                                points: [{x: -130, y: 0}, {x: -116, y: 0}, {x: -116, y: 14}, {x: -130, y: 14}]
                            }
                        ]
                    },
                    {
                        text: 'Oxygen Warning Sign has been Posted',
                        bold: false,
                        fontSize: 10,
                        color: '#333333',
                        margin: [-240, 0, 0, 3],
                    },
                ]
            },
            '\n',
            {
                columns: [

                    {
                        text: `Questionnaire and Rental Agreement \n _____ I understand that it is my responsibility to \n call  for any equipment malfunction. \n _____ I understand that only equipment \n personnel may disassemble equipment. \n_____ I have been thoroughly trained and fully \n understand how to safely operate the above \n equipment.\n \n For all license and permit information's please \n visit: www.capstonehme.com/permits`,
                        style: 'small'
                    },
                    {
                        stack: [
                            {
                                text: 'Medical Oxygen Information',
                                bold: false,
                                fontSize: 10,
                                color: '#333333',
                                margin: [0, 0, 0, 3],
                                alignment: "center"
                            },
                            {
                                text: 'Filled By:',
                                bold: true,
                                fontSize: 10,
                                color: '#333333',
                                margin: [0, 0, 0, 3],
                            },
                            {
                                text: `${order.supplier_name ? order.supplier_name : ""}`,
                                bold: false,
                                fontSize: 10,
                                color: '#333333',
                                margin: [0, 0, 0, 3],
                            },
                            {
                                text: `${order.oxygen_address1 ? order.oxygen_address1 : ""} ${order.oxygen_address2 ? order.oxygen_address2 : ""}`,
                                bold: false,
                                fontSize: 10,
                                color: '#333333',
                                margin: [0, 0, 0, 3],
                            },
                            {
                                text: `${order.oxygen_city ? order.oxygen_city : ""} ${order.oxygen_state ? order.oxygen_state : ""} ${order.oxygen_zip ? order.oxygen_zip : ""}`,
                                bold: false,
                                fontSize: 10,
                                color: '#333333',
                                margin: [0, 0, 0, 3],
                            },
                            {
                                text: 'Provided By:',
                                bold: true,
                                fontSize: 10,
                                color: '#333333',
                                margin: [0, 0, 0, 3],
                            },
                            {
                                text: `${order.dme_name ? order.dme_name : ""}`,
                                bold: false,
                                fontSize: 10,
                                color: '#333333',
                                margin: [0, 0, 0, 3],
                            },
                            {
                                text: `${order.dme_organization_address1 ? order.dme_organization_address1 : ""} ${order.dme_organization_address2 ? order.dme_organization_address2 : ""}`,
                                bold: false,
                                fontSize: 10,
                                color: '#333333',
                                margin: [0, 0, 0, 3],
                            },
                            {
                                text: `${order.dme_organization_city ? order.dme_organization_city : ""} ${order.dme_organization_state ? order.dme_organization_state : ""} ${order.dme_organization_zip ? order.dme_organization_zip : ""}`,
                                bold: false,
                                fontSize: 10,
                                color: '#333333',
                                margin: [0, 0, 0, 3],
                            },
                            {
                                text: `Shipped to: Patient, see above`,
                                bold: false,
                                fontSize: 10,
                                color: '#333333',
                                margin: [0, 0, 0, 3],
                            },
                            {
                                text: 'License Information',
                                bold: true,
                                fontSize: 10,
                                color: '#333333',
                                margin: [0, 0, 0, 3],
                            },
                            {
                                text: `${order.dme_retail ? order.dme_retail : ""}`,
                                bold: false,
                                fontSize: 10,
                                color: '#333333',
                                margin: [0, 0, 0, 3],
                            },
                            {
                                text: `${order.dme_wholesale ? order.dme_wholesale : ""}`,
                                bold: false,
                                fontSize: 10,
                                color: '#333333',
                                margin: [0, 0, 0, 3],
                            },
                        ],
                    }
                ]
            },

            '\n\n',
            {
                table: {

                    widths: [240, 255],
                    heights: ['*', 1],
                    alignment: 'center',
                    body: [
                        [
                            {
                                text: '',

                                fontSize: 1,
                                alignment: 'left',
                                bold: true,
                                border: [false, true, false, false],
                                margin: [100, 1, 0, 1],
                                textTransform: 'uppercase',
                            },

                            {
                                text: '',
                                border: [false, true, false, false],
                                alignment: 'right',
                                fontSize: 1,
                                bold: true,
                                margin: [0, 1, 100, 1],
                                textTransform: 'uppercase',
                            },
                        ]
                    ]

                },

            },
            {
                columns: [

                    {
                        text: 'Technician Signature',
                        bold: false,
                        fontSize: 10,
                        color: '#333333',
                        margin: [20, 0, 0, 3],
                    },

                    {
                        text: 'Date:',
                        bold: false,
                        fontSize: 10,
                        color: '#333333',
                        margin: [20, 0, 0, 3],
                    },
                    {
                        text: 'Patient / Caregiver Signature',
                        bold: false,
                        fontSize: 10,
                        color: '#333333',
                        margin: [20, 0, 0, 3],
                    },
                    {
                        text: 'Date',
                        bold: false,
                        fontSize: 10,
                        color: '#333333',
                        margin: [20, 0, 0, 3],
                    },


                ]
            },

        ],
        styles: {
            notesTitle: {
                fontSize: 10,
                bold: true,
                margin: [0, 6, 0, 0],
            },
            notesText: {
                fontSize: 10,
            },
            small: {
                fontSize: 10
            },
            end: {
                width: '100%',
                textAlign: 'right'
            }
        },
        defaultStyle: {
            columnGap: 20,
        },
        footer: function (currentPage, pageCount) {
            return {
                margin: 10,
                columns: [
                    {
                        fontSize: 9,
                        text: [

                            {
                                text: 'Page' + currentPage.toString() + ' of ' + pageCount,
                            }
                        ],
                        alignment: 'center',
                        margin: [0, 4, 0, 3],
                    }
                ]
            };

        },
    };
    if (name === 'download') {
        pdfMake.createPdf(template).download(`Delivery_order_${orderId}.pdf`);
    } else if (name === 'print') {
        pdfMake.createPdf(template).print();
    }
};
